/* eslint-disable key-spacing, no-multi-spaces */
export const CountryIso = {
  INDIA:             'IN',
  CANADA:            'CA',
  UNITED_STATES:     'US',
  AUSTRALIA:         'AU',
  NEW_ZEALAND:       'NZ',
  GREAT_BRITAIN:     'GB',
  IRELAND:           'IE',
  AUSTRIA:           'AT',
  BELGIUM:           'BE',
  BULGARIA:          'BG',
  CYPRUS:            'CY',
  CZECH_REPUBLIC:    'CZ',
  DENMARK:           'DK',
  ESTONIA:           'EE',
  FINLAND:           'FI',
  FRANCE:            'FR',
  GERMANY:           'DE',
  GREECE:            'GR',
  HUNGARY:           'HU',
  ITALY:             'IT',
  LATVIA:            'LV',
  LITHUANIA:         'LT',
  LUXEMBOURG:        'LU',
  MALTA:             'MT',
  NETHERLANDS:       'NL',
  NORWAY:            'NO',
  POLAND:            'PL',
  PORTUGAL:          'PT',
  ROMANIA:           'RO',
  SLOVAKIA:          'SK',
  SLOVENIA:          'SI',
  SPAIN:             'ES',
  SWEDEN:            'SE',
  SWITZERLAND:       'CH',
  EUROPEAN_UNION:    'EU',
  REST_OF_THE_WORLD: 'ROW'
}

export const getCountryByISO = (iso) => {
  const region = Object.keys(CountryIso).find((key) => CountryIso[key] === iso)
  return region || CountryIso.REST_OF_THE_WORLD
}

export const LanguageGroup = {
  [CountryIso.AUSTRALIA]:      'en-AU',
  [CountryIso.GREAT_BRITAIN]:  'en-GB',
  [CountryIso.NEW_ZEALAND]:    'en-NZ',
  [CountryIso.UNITED_STATES]:  'en-US',
  [CountryIso.AUSTRIA]:        'en-DE',
  [CountryIso.BELGIUM]:        'en-DE',
  [CountryIso.BULGARIA]:       'en-DE',
  [CountryIso.CYPRUS]:         'en-DE',
  [CountryIso.CZECH_REPUBLIC]: 'en-DE',
  [CountryIso.DENMARK]:        'en-DE',
  [CountryIso.ESTONIA]:        'en-DE',
  [CountryIso.FINLAND]:        'en-DE',
  [CountryIso.FRANCE]:         'en-DE',
  [CountryIso.GERMANY]:        'en-DE',
  [CountryIso.GREECE]:         'en-DE',
  [CountryIso.HUNGARY]:        'en-DE',
  [CountryIso.ITALY]:          'en-DE',
  [CountryIso.LATVIA]:         'en-DE',
  [CountryIso.LITHUANIA]:      'en-DE',
  [CountryIso.LUXEMBOURG]:     'en-DE',
  [CountryIso.MALTA]:          'en-DE',
  [CountryIso.NETHERLANDS]:    'en-DE',
  [CountryIso.NORWAY]:         'en-DE',
  [CountryIso.POLAND]:         'en-DE',
  [CountryIso.PORTUGAL]:       'en-DE',
  [CountryIso.ROMANIA]:        'en-DE',
  [CountryIso.SLOVAKIA]:       'en-DE',
  [CountryIso.SLOVENIA]:       'en-DE',
  [CountryIso.SPAIN]:          'en-DE',
  [CountryIso.SWEDEN]:         'en-DE',
  [CountryIso.SWITZERLAND]:    'en-DE',
  [CountryIso.EUROPEAN_UNION]: 'en-DE',
  PAY:                         'en-DE', // Timely Page
  NON_PAY:                     'en-IN'  // Non Timely Page
}
